<template>
  <div>
    <div id="experience" class="single-exp" align="left">
          <div v-if="work.designation" class="resume-view-header">{{ work.designation }}</div>
          <div v-if="work.designation">{{
            calculateDuration() + calculateDurationInYears()
          }}</div>
       
        <div >{{ work.company_name }}</div>
        <div v-if="work.location_name">
          {{ work.location_name }}
        </div>
        <div class="resume-view-details">
          {{work.experience_description}}
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "experience-card",
  components: {},
  props: {
    job: Object,
    index: Number
  },
  data: function() {
    return {
      work: this.job,
      check: 0,
      overflowed: false,
      truncateView: true
    };
  },
  methods: {
    calculateDuration: function() {
      const self = this;
      let start = self.work.start_year;
      let end;
      if (self.work.is_working) {
        end = "Present";
      } else {
        end = self.work.end_year;
      }
      return start + " - " + end;
    },
    calculateDurationInYears: function() {
      const self = this;
      let msg = "";
      let start = self.work.start_year;
      let end;
      if (self.work.is_working) {
        end = new Date().getFullYear();
      } else {
        end = self.work.end_year;
      }
      let total = end - start;
      if (total === 0) {
        msg = " (Less than a year)";
      } else if (total > 0) {
        let y = " years)";
        if (total === 1) {
          y = " year)";
        }
        msg = " (Over " + total + y;
      } else {
        msg = "Invalid";
      }
      return msg;
    }
  }
  
};
</script>

<style scoped>
.image-wrapper {
  text-align: left;
  margin-top: 1rem;
}
.num-wrapper {
  color: #3d4249;
  border: 0.1rem solid #3d4249;
  border-radius: 50%;
  padding: 0.1rem 0.6rem;
}
.single-exp {
  padding: 1rem 0;
}
.exp-details {
  padding: 0;
  text-align: left;
}
.company {
  font-size: 16px;
  letter-spacing: 0;
}
.designation {
  padding: 0;
  font-weight: bold;
  font-size: 16px;
  letter-spacing: 0;
}
.location {
  font-weight: lighter;
  font-size: 14px;
  letter-spacing: 0;
}
.description {
  font-size: 14px;
  letter-spacing: 0;
  width: 550px;
  overflow: hidden;
}
.exp-details-years {
  padding: 2px 0 0 2%;
  font-weight: lighter;
  font-size: 14px;
  letter-spacing: 0;
}
.more-less {
  color: #207688;
}
</style>
